import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Personalities({ items = [] }) {
    const ref = useRef(null);
    const scroll = (dir) =>
        ref.current?.scrollBy({
            left: dir * 320,
            behavior: "smooth",
        });

    return (
        <section data-testid="featured-personalities-section" className="mt-16">
            <div className="flex items-center justify-between mb-6">
                <h2 className="brand-section font-display uppercase text-3xl md:text-5xl text-white tracking-tight">
                    Featured Personalities
                </h2>
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => scroll(-1)}
                        aria-label="Scroll left"
                        data-testid="personalities-scroll-left"
                        className="h-10 w-10 border border-streetz-line text-white hover:bg-streetz-red hover:border-streetz-red"
                    >
                        <ChevronLeft className="w-5 h-5 mx-auto" />
                    </button>
                    <button
                        onClick={() => scroll(1)}
                        aria-label="Scroll right"
                        data-testid="personalities-scroll-right"
                        className="h-10 w-10 border border-streetz-line text-white hover:bg-streetz-red hover:border-streetz-red"
                    >
                        <ChevronRight className="w-5 h-5 mx-auto" />
                    </button>
                </div>
            </div>

            <div
                ref={ref}
                className="flex gap-6 md:gap-8 overflow-x-auto scrollbar-hide pb-2"
            >
                {items.map((p, i) => (
                    <div
                        key={p.id || i}
                        data-testid={`personality-${i}`}
                        className="flex flex-col items-center shrink-0 w-28 md:w-36 group cursor-pointer"
                    >
                        <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden border-2 border-transparent group-hover:border-streetz-red transition-colors grayscale group-hover:grayscale-0">
                            <img
                                src={p.image_url}
                                alt={p.name}
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="font-display uppercase text-base md:text-lg text-white mt-3 text-center">
                            {p.name}
                        </div>
                        <div className="text-xs text-streetz-muted text-center">
                            {p.role}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
